// extracted by mini-css-extract-plugin
module.exports = {"slate-embed-plugin--node":"EmbedNode_slate-embed-plugin--node__-DQMf","active":"EmbedNode_active__261bz"};